// Build-time configuration from Vite's env files (.env.<mode>, see .env.example). Nothing here is secret: it is
// all compiled into the public bundle.
const env = import.meta.env;

/** Base URL of the Sensay API, ending with "/". */
export const API_BASE_URL = env.VITE_API_BASE_URL.endsWith('/') ? env.VITE_API_BASE_URL : env.VITE_API_BASE_URL + '/';

/** Whether analytics vendors are loaded and called (on in production builds unless VITE_ANALYTICS=off). */
export const ANALYTICS_ENABLED = env.VITE_ANALYTICS ? env.VITE_ANALYTICS === 'on' : env.PROD;
